<ng-container *ngIf="!removed else groupRemoved">
  <div class="modal modal_size_488 modal__opened">
    <div class="modal__container">
      <div class="modal__title modal__title-mb12 h2">{{ 'delete-group-modal.title' | translate }}</div>
      <div class="modal__text">{{ 'delete-group-modal.text' | translate }}</div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button" [class.button_type_load]="requestInProgress" (click)="delete()">{{ 'delete-group-modal.delete' | translate }}</div>
      <div class="button button_type_light" (click)="close()">{{ 'delete-group-modal.cancel' | translate }}</div>
    </div>
  </div>
</ng-container>

<ng-template #groupRemoved>
  <div class="modal modal_size_744 modal__opened">
    <div class="modal__close icon icon-close" (click)="close()"></div>
    <div class="modal__container">
      <div class="modal__img">
        <div class="modal-img modal-img_name_congratulations modal-img_size_192"></div>
      </div>
      <div class="modal__title modal__title-mb12 h2">{{ 'delete-group-modal.group-removed' | translate }}</div>
      <div class="modal__text">{{ 'delete-group-modal.rules-deleted' | translate }}</div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button" (click)="close()">{{ 'delete-group-modal.ok-btn' | translate }}</div>
    </div>
  </div>
</ng-template>
